// Pomocne funkce pro praci s daty.
// Vnitrne pouzivame ISO format YYYY-MM-DD (kompatibilni s <input type="date">).
// Pro zobrazeni / tisk pouzivame cesky format D.M.YYYY.

/** @returns {string} ISO datum (YYYY-MM-DD) dnesniho dne v lokalni casove zone. */
export function todayIso() {
  return toIso(new Date());
}

/**
 * Prida zadany pocet dni k ISO datu.
 * @param {string} iso ISO datum YYYY-MM-DD
 * @param {number} days kolik dni pricist (muze byt zaporne)
 * @returns {string} nove ISO datum
 */
export function addDaysIso(iso, days) {
  const d = fromIso(iso);
  if (!d) return iso;
  d.setDate(d.getDate() + days);
  return toIso(d);
}

/**
 * Naformatuje ISO datum do ceskeho zapisu (D.M.YYYY).
 * Prazdny vstup vraci prazdny retezec.
 * @param {string} iso
 * @returns {string}
 */
export function formatCz(iso) {
  const d = fromIso(iso);
  if (!d) return '';
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
}

function toIso(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function fromIso(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return Number.isNaN(d.getTime()) ? null : d;
}
